import state from './state';

export const showLive = () => {
  state.viewInfo.endBox = false;
  state.viewInfo.videoBg = false;
  state.viewInfo.loading = false;
  state.viewInfo.controlBox = true;
  state.viewInfo.infoBox = true;
};

export const hostLeave = () => {
  state.viewInfo.leaveBox = true;
  state.viewInfo.videoBg = true;
};

export const hostBack = () => {
  state.viewInfo.leaveBox = false;
  state.viewInfo.videoBg = false;
};

export const showEnd = () => {
  state.viewInfo.loading = false;
  state.viewInfo.controlBox = false;
  state.viewInfo.videoBg = false;
  state.viewInfo.endBox = true;
  state.viewInfo.infoBox = true;
};

export const resetInfo = () => {
  state.liveInfo = {};
  state.viewInfo.infoBox = false;
};
